// extracted by css-extract-rspack-plugin
export default {"how-to-play":"fb4n84ZITsqoWXLW","howToPlay":"fb4n84ZITsqoWXLW","title":"Kf6LxW_lQEWOPV9C","version":"_h8Q1fjKMpgSfsPM","label":"SjO648hOBX4fRiAj"};